import type { SpinResponse } from "@slot/client-engine";
import { fx, spinFixture } from "@slot/game-shell";

/**
 * BONUS HUNT mode — scatter near-miss tease. Two FS scatters land early (reels 1 + 2),
 * the remaining reels are server-flagged to anticipate, and the third scatter never
 * comes. No win. The bonus-hunt base pool leans on fixtures like this so mode-on spins
 * FEEL hunt-y (teases + a much higher trigger rate than the normal base pool).
 */
export function baseFixtureBonusHuntTease(): SpinResponse {
  return spinFixture("bonus-hunt-tease")
    .balance("EUR", "100000")
    .event("reveal", 0, (e) => {
      // FS on reels 1 + 2 (cols 0 + 1) → reels 3..5 (indices 2..4) anticipate, no third FS.
      e.reelSet("default").accumulatedWinAfter("0")
        .gridRows([
          ["FS", "L4", "L1", "L2", "L3"],
          ["L3", "FS", "L4", "L1", "L5"],
          ["L1", "L2", "L5", "L3", "L1"],
          ["L2", "L3", "L2", "L4", "L1"],
        ])
        .anticipate([2, 3, 4]);

      const s = fx.spinBoundaryStart("base:1", "base");
      e.action(s.type, s.payload, { actionPhaseName: s.phase, debugTag: "start" });

      const end = fx.spinBoundaryEnd("base:1", "0");
      e.action(end.type, end.payload, { actionPhaseName: end.phase, debugTag: "end" });
    })
    .build();
}
